import * as Sentry from '@sentry/browser'

export function getUserScope() {
    return new Promise(resolve => {
        Sentry.withScope(scope => resolve(scope._user));
    });
}

export function resetUserScope() {
    Sentry.configureScope(scope => scope.setUser(null));
}

export function configureScopeWithUser(user) {
    if(!user) {
        return resetUserScope();
    }

    Sentry.configureScope(scope => {
        scope.setUser({
            id: user.id,
            username: user.email
        });
    });
}

export default function() {
    if (process.env.NODE_ENV !== 'development') {
        Sentry.init({ 
            dsn: 'https://19372cad3638483480f80435de02097d@o221045.ingest.sentry.io/1504830',
            ignoreErrors: [
                /Network Error/,
                /Request failed with status code/,
                /Request aborted/
            ]
        });
    }
}